/**
 * search page reducer module
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/16
 */
import { combineReducers } from 'redux';
import { RECEIVE_QUERY_PRODUCT, RECEIVE_SEARCH_TIP } from '../actions/search';

/**
 * init state
 */
const initState = {
  searchTip: [],
  product: { resultList: [], pageSize: 8, totalCount: 1, totalPages: 1, current: 1, query: ' ' }
}

/**
 * query result reducer
 */
export const product = (state = initState.product, action) => {
  switch (action.type) {
    case RECEIVE_QUERY_PRODUCT:
      return action.product;
    default:
      return state;
  }
}

export const searchTip = (state = initState.searchTip, action) => {
  switch (action.type) {
    case RECEIVE_SEARCH_TIP:
      return action.searchTip;
    default:
      return state;
  }
}

export default combineReducers({
  product,
  searchTip
})


// WEBPACK FOOTER //
// ./src/reducers/search.js